module.exports = __webpack_public_path__ + "media/img/Landing_Page/logos/8-264fc72208d8846566fd69a56ec14ed1.jpg";